var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getConfig } from "@jti/fe-common";
export class MapApi {
    constructor() {
        this.name = "MapApi";
    }
    static init() {
        return new MapApi();
    }
    getSelectedCountries(countriesApiUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            const config = getConfig();
            return yield fetch(countriesApiUrl || config.PLATFORM_CONFIGURATION_URL).then((response) => response.json());
        });
    }
}
//# sourceMappingURL=MapApi.js.map